const autoNgTemplateLoaderTemplate1 = require('./git-form-url-field.html');

export const gitFormUrlField = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    value: '<',
    onChange: '<',
  },
};
